import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { CustomSqlFragmentGql } from "./CustomSqlFragmentGql";

export const PublishedDatasourceCustomSqlQueryGql: DocumentNode = gql`
  query PublishedDatasourceCustomSqlQuery($vizportalUrlId: String!) {
    publishedDatasources(filter: { vizportalUrlId: $vizportalUrlId }) {
      ...CustomSqlFragment
    }
  }
  ${CustomSqlFragmentGql}
`;
